export const GET_AREA_LIST = 'GET_AREA_LIST'
export const GET_AREA_TEMATICA_LIST = 'GET_AREA_TEMATICA_LIST'
export const GET_AREA_RISERVATA_ENUM_LIST = 'GET_AREA_RISERVATA_ENUM_LIST'
export const GET_REGIONE_LIST = 'GET_REGIONE_LIST'
export const GET_TRAINING_COURSE_TYPES_LIST = 'GET_TRAINING_COURSE_TYPES_LIST'
